import React from 'react';

import { withQueryString } from 'src/components/app-context/link-to';
import { Banner, CampaignLink, LinkText, Text } from './styles';
import type { Campaign, CampaignBanner } from '../../../types';
import { IconChevronRight } from '@prisjakt/ui/icon/chevron-right';

type Props = {
  banners: BannerType[];
  className?: string;
  inverted?: boolean;
  linkParams?: object;
};

type BannerType = Pick<CampaignBanner, 'options'> & {
  campaign: Pick<Campaign, 'media'>;
};

const PromoBanner = ({
  banners,
  className,
  inverted = false,
  linkParams,
}: Props) => {
  if (!banners?.length) return null;

  // TODO: render banner based on priority
  const activeBanner = banners[0];
  const options = activeBanner.options || {};

  const customLink = options.customLink && options.customLink.url;
  const path =
    customLink && linkParams
      ? withQueryString(customLink, linkParams)
      : customLink;
  const tagline = (options.tagline && options.tagline.text) || '';
  const linkText = (options.customLink && options.customLink.text) || '';
  const color = options.fallbackColor || '#000';
  const logo =
    (options.showLogo !== false &&
      activeBanner.campaign &&
      activeBanner.campaign.media &&
      activeBanner.campaign.media.images &&
      activeBanner.campaign.media.images.icon) ||
    undefined;

  if (!path) {
    return null;
  }

  return (
    <Banner
      className={className}
      to={path}
      logo={logo}
      $themeColor={color}
      $inverted={inverted}
    >
      <Text $inverted={inverted} $themeColor={color}>
        {tagline}
      </Text>

      <CampaignLink $themeColor={color} $inverted={inverted}>
        {linkText && <LinkText>{linkText}</LinkText>}
        <IconChevronRight />
      </CampaignLink>
    </Banner>
  );
};

export default PromoBanner;
